export default __webpack_public_path__ + "0a8093e558c41e9ce191012f9f5f648c.svg";